import { trackEvent } from '~/features/analytics/track-event';
import {
  getHalloween2026CheckoutHref,
  HALLOWEEN_2026_ASSETS,
  HALLOWEEN_2026_COLORS,
  HALLOWEEN_2026_CTA_LABEL,
  HALLOWEEN_2026_EYEBROW_LABEL,
  HALLOWEEN_2026_HEADLINE_PREFIX,
  HALLOWEEN_2026_VARIANTS,
} from '~/features/promotions/constants/halloween-2026';
import type { Halloween2026Variant } from '~/features/promotions/utils/get-halloween-2026-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

import { Halloween2026CatalogBanner } from './catalog-banner';
import { Halloween2026HomepageCard } from './homepage-card';

const HALLOWEEN_2026_ANALYTICS_LABEL = 'halloween_2026_sale_clicked';

export const halloween2026CampaignSurfaces: PromoCampaignSurfaceRenderers<Halloween2026Variant>['surfaces'] = {
  homepage: ({ resolved, promoCode, imagePriority }) => (
    <Halloween2026HomepageCard
      checkoutHref={getHalloween2026CheckoutHref(resolved, promoCode)}
      imagePriority={imagePriority}
      variant={resolved}
      onClick={() =>
        trackEvent({
          type: 'click',
          name: 'Homepage CTA Clicked',
          label: HALLOWEEN_2026_ANALYTICS_LABEL,
        })
      }
    />
  ),
  catalog: ({ resolved, promoCode, imagePriority }) => (
    <Halloween2026CatalogBanner
      checkoutHref={getHalloween2026CheckoutHref(resolved, promoCode)}
      imagePriority={imagePriority}
      variant={resolved}
      onClick={() =>
        trackEvent({
          type: 'click',
          name: 'Catalog Page CTA Clicked',
          label: HALLOWEEN_2026_ANALYTICS_LABEL,
        })
      }
    />
  ),
  experience: ({ resolved, promoCode }) => {
    const copy = HALLOWEEN_2026_VARIANTS[resolved];

    return {
      id: `halloween_2026_${resolved}`,
      promoVariant: 'flash_sale',
      eyebrow: HALLOWEEN_2026_EYEBROW_LABEL,
      title: HALLOWEEN_2026_HEADLINE_PREFIX,
      titleLine2: copy.experienceOffer,
      description: copy.experienceSubtitle,
      ctaLabel: HALLOWEEN_2026_CTA_LABEL,
      flashSale: {
        backgroundGradient: 'linear(to-b, black, black)',
        backgroundImage: HALLOWEEN_2026_ASSETS.experienceAtfBg,
        backgroundImageMobile: HALLOWEEN_2026_ASSETS.experienceAtfBgMobile,
        backgroundImageObjectPosition: 'center',
        bodyColor: HALLOWEEN_2026_COLORS.subtitle,
        ctaBackgroundColor: HALLOWEEN_2026_COLORS.cta,
        eyebrowColor: HALLOWEEN_2026_COLORS.eyebrow,
        titleAccentColor: HALLOWEEN_2026_COLORS.accent,
      },
      action: {
        type: 'link',
        href: getHalloween2026CheckoutHref(resolved, promoCode),
      },
    };
  },
};
